// 撤銷裝置短命 tombstone(18 §3.3,APP#123)。GET /v3/devices 走 DynamoDB GSI
// (restful device.go user-index),無 read-your-writes:force_logout 後立刻 reload
// 可能讀到未收斂的 GSI,把剛樂觀移除的裝置蓋回清單(幽靈裝置,行動端無週期
// reload 可掛整個 session)。故 device-scope 撤銷帶到的 device_id 進 tombstone,
// 每次 reload 結果寫入清單前過濾,直到三個清除時機之一:
//   a) 某次 reload 本來就不含該 id(GSI 已收斂)——filter() 內自動清;
//   b) TTL 到期(保底;GSI 非單調讀理論上可能在 a) 後再吐 stale,由 TTL 涵蓋);
//   c) 同一台重新綁定/接受分享成功 → clear(id)(否則 30s 窗內解綁重配會被自己濾掉)。
// 換帳號防串染:endSession → clearAll()。

export const REVOKED_TOMBSTONE_TTL_MS = 30_000;

export class RevokedTombstones {
  private expiries = new Map<string, number>();

  add(deviceId: string, now = Date.now()): void {
    this.expiries.set(deviceId, now + REVOKED_TOMBSTONE_TTL_MS);
  }

  clear(deviceId: string): void {
    this.expiries.delete(deviceId);
  }

  clearAll(): void {
    this.expiries.clear();
  }

  /** reload 結果過濾:先清過期與已收斂(結果中不存在)的 id,再濾掉其餘。 */
  filter<T>(list: T[], idOf: (item: T) => string, now = Date.now()): T[] {
    if (this.expiries.size === 0) return list;
    for (const [id, exp] of this.expiries) {
      if (exp <= now) this.expiries.delete(id);
    }
    if (this.expiries.size === 0) return list;
    const present = new Set(list.map(idOf));
    for (const id of this.expiries.keys()) {
      if (!present.has(id)) this.expiries.delete(id);
    }
    if (this.expiries.size === 0) return list;
    return list.filter((item) => !this.expiries.has(idOf(item)));
  }
}

/** App 級單例:useDeviceList 過濾、PairingPanel/SharedWithMeCard 清除、AuthContext 清空。 */
export const revokedTombstones = new RevokedTombstones();
